import React from 'react';

import { Outlet } from 'react-router-dom';

import { AuthenticatedTemplate } from '@/modules/common';
import { BackendFeatureFlagsProvider } from '@/modules/common/context/backend-feature-flags-context';

const PrivatePage: React.FC = () => {
  return (
    <BackendFeatureFlagsProvider>
      <AuthenticatedTemplate>
        <Outlet />
      </AuthenticatedTemplate>
    </BackendFeatureFlagsProvider>
  );
};

export default PrivatePage;
